import environment from '~/platform/utilities/environment';

export const SUBMIT_URL = `${environment.API_URL}/v0/education_benefits_claims/8794`;

export const OMB_RES_BURDEN = 10;
export const OMB_NUMBER = '2900-0262';
export const OMB_EXP_DATE = '08/31/2027';
